import { useEffect } from 'react';
import {
  type DefaultTheme,
  StyleSheetManager,
  ThemeProvider as StyledThemeProvider,
} from 'styled-components';

import useColor from '@/hooks/domain/useColor';
import useShadow from '@/hooks/domain/useShadow';
import { useSidebarWidth } from '@/hooks/domain/useSidebar';
import useUIStore, { getSystemTheme } from '@/stores/pure/UIStore';

import { radius } from './sizes';
import { shouldForwardStyledProp } from './styled-bridge';

export function CopositeThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const color = useColor();
  const colorTheme = useUIStore((state) => state.colorMode);
  const shadow = useShadow();
  const sidebarWidth = useSidebarWidth();

  const theme: DefaultTheme = {
    colors: color,
    radius: radius,
    colorTheme: colorTheme === 'system' ? getSystemTheme() : colorTheme,
    shadow: shadow,
    sidebarWidth: sidebarWidth,
  };

  useEffect(() => {
    // class 대신 data-theme 속성 사용
    document.documentElement.setAttribute('data-theme', colorTheme);
  }, [colorTheme]);

  return (
    <StyleSheetManager
      enableVendorPrefixes
      shouldForwardProp={shouldForwardStyledProp}
    >
      <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
    </StyleSheetManager>
  );
}
